import { useContext } from "react"
import { Link } from "react-router-dom"

import tagsContext from "../../context/tags"


function Tag({ tagId }) {
    const tags = useContext(tagsContext)
    const [tag] = tags.filter(tag => tag.id === tagId)
    const { text, foreClr, bgClr } = tag

    return <>
        <Link to="#">
            <span className="tag tag-sm" style={{ color: foreClr, backgroundColor: bgClr }}>
                #{text}
            </span>
        </Link>
    </>
}


export default Tag
